/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PastiNonOrdinariSpecifici } from './pasti-non-ordinari-specifici';


export interface ResocontoPastiClasseSezione { 
    classe?: string;
    sezione?: string;
    numero_pasti_ordinari?: number;
    alunni?: string;
    pasti_non_ordinari_specifici?: Array<PastiNonOrdinariSpecifici>;
}

